import { Pano } from "../Pano.js";
import { BaseControl, ControlPosition } from "./BaseControl.js";
import { VOMarker } from "../../model/Structure.js";
import { Language } from "../../model/Language.js";
import { PanoButton } from "../PanoButton.js";

export class ControlMarkerlist extends BaseControl {

    private _list: HTMLElement;
    private _active: boolean = false;
    private _items: ControlMarkerlistItem[] = [];
    private _button:PanoButton;

    constructor(pano: Pano) {
        super(pano);

        this._button = this.pano.addButton(
            {
                // icon: "fal fa-sign-post",
                icon: "fal fa-location-dot",
                position: ControlPosition.RIGHT,
                selected: this._active,
                tooltip: Language.resolve("Markerliste", "Marker list"),
                onInit: (item) => {
                    this.pano.onChangeVideo.add((d) => {
                        item.visible = d && d.markers && d.markers.length > 0;
                    });
                },
                onClick: (item) => {
                    this.active = !this.active;
                }
            }
        );

        const updateButtonVisibility = () => {
            this._button.visible = this.pano.current && this.pano.current.markers && this.pano.current.markers.length > 0;
        };
        updateButtonVisibility();
        this.pano.onChangeVideo.add(updateButtonVisibility);

        this._list = document.createElement("div");
        this._list.classList.add("marker-list");
        this._list.classList.add("hidden");
        this._list.classList.toggle("active", this._active);
        this.pano.overlay.appendChild(this._list);

        pano.onChangeVideo.add((video) => {
            for (var item of this._items){
                item.dispose();
            }

            this._items = [];
            this._list.innerHTML = "";

            const visible = video && video.markers && video.markers.length > 0;
            this._list.classList.toggle("hidden", !visible);
            if (!visible) {
                return;
            }

            for (var marker of video.markers) {
                this.addItem(marker);
            }
        });
    }

    private get active(): boolean {
        return this._active;
    }

    private set active(active: boolean) {
        if (this._active === active)
            return;
        this._active = active;
        this._button.selected = active;
        this._list.classList.toggle("active", active);
    }

    private addItem(marker: VOMarker): void {
        var item = new ControlMarkerlistItem(marker, this.pano);
        this._items.push(item);
        this._list.appendChild(item.element);
    }
}

class ControlMarkerlistItem {
    public element: HTMLElement;
    private _marker: VOMarker;
    private _onClick: (e: MouseEvent) => void;

    constructor(marker: VOMarker, public pano: Pano) {
        this._marker = marker;

        this.element = document.createElement("button");
        this.element.className = "marker-list__item";

        var label = document.createElement("div");
        label.classList.add("marker-list__item-label");
        Language.apply(label, marker.marker_label_de, marker.marker_label);
        this.element.appendChild(label);

        //Arrow right "icon-124".
        //Magnify "icon-479"
        var trigger = document.createElement("div");
        trigger.classList.add("marker-list__item-trigger");
        trigger.classList.add(...marker.marker_icon.split(" "));
        this.element.appendChild(trigger);

        this._marker.delegates.push(this);

        this._onClick = (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();
            this.trigger();
        };

        this.element.addEventListener("click", this._onClick);
    }

    public trigger(): void {
        this.pano.view.lookAtMarker(this._marker);
    }

    public get visible(): boolean {
        return !this.element.classList.contains("hidden");
    }

    public set visible(visible: boolean) {
        this.element.classList.toggle("hidden", !visible);
    }

    public dispose(): void {
        this.element.removeEventListener("click", this._onClick);
        this._marker.delegates.splice(this._marker.delegates.indexOf(this), 1);
        this.element.remove();
    }
}